// eslint-disable-next-line @nx/enforce-module-boundaries
import { useReferralCode } from '@ocx/feat-referrals';
import { useConfiguration } from '@ocx/data-configuration';

import { useEnterReferralCodeActionSheet } from './components/enter-referral-code-popup';
import { useSignupPhoneNumberFormController } from './use-signup-phone-number-form-controller.hook';
import { SignupPhoneNumberForm } from './signup-phone-number-form.component';
import { RequestMagicLinkParams, RequestOtpParams } from '../../signup.types';

type SignupPhoneNumberFormControllerProps = {
  phoneNumber: string | null;
  isBlockedByTimeout: boolean;
  handleRequestMagicLink(params: RequestMagicLinkParams): Promise<boolean>;
  handleRequestOTP(params: RequestOtpParams): Promise<boolean>;
};

export const SignupPhoneNumberFormController = (props: SignupPhoneNumberFormControllerProps) => {
  const { phoneNumber, isBlockedByTimeout, handleRequestMagicLink, handleRequestOTP } = props;

  const referralCode = useReferralCode();

  const {
    config: {
      termsConditions: { url: termsConditionsLink },
      privacyPolicy: { url: privacyPolicyLink },
      loyaltyProgram: { referralProgramConfig },
      personalDataShareOptOut,
    },
  } = useConfiguration();

  const { handleSubmit } = useSignupPhoneNumberFormController({
    isBlockedByTimeout,
    handleRequestMagicLink,
    handleRequestOTP,
  });

  const { open: openEnterReferralCodeActionSheet } = useEnterReferralCodeActionSheet();
  const isReferralCodeManualEntryEnabled =
    !!referralProgramConfig?.referralProgramEnabled && referralProgramConfig.referralCodeManualEntryEnabled;

  return (
    <SignupPhoneNumberForm
      phoneNumber={phoneNumber || ''}
      onSubmit={handleSubmit}
      termsOfServiceLink={termsConditionsLink}
      privacyPolicyLink={privacyPolicyLink}
      referralCode={referralCode}
      isReferralCodeManualEntryEnabled={isReferralCodeManualEntryEnabled}
      onReferralProgramManualEntryClick={openEnterReferralCodeActionSheet}
      optOutUrl={personalDataShareOptOut?.enabled ? personalDataShareOptOut.optOutUrl : undefined}
    />
  );
};
